import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';

import logo from './logo.png';
import styles from './styles.js';
import GlobalDrawer from './GlobalDrawer/GlobalDrawer.js';
import GlobalDrawerList from './GlobalDrawer/GlobalDrawerList/GlobalDrawerList.js';
import Breadcrumbs from './Breadcrumbs/Breadcrumbs';
import LocaleSelector from '../LocaleSelector/LocaleSelector';
import PortalBanner from './PortalBanner/PortalBanner';

import { getString } from '../../helpers/stringHelpers';

const stringsComponent = 'app';

class PortalAppBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drawerOpen: false,
    };

    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.handleLogoClick = this.handleLogoClick.bind(this);
  }

  toggleDrawer() {
    const { drawerOpen } = this.state;
    this.setState({
      drawerOpen: !drawerOpen,
    });
  }

  skip(e) {
    e.preventDefault();
    document.getElementById('main').focus();
  }

  handleLogoClick(e) {
    e.preventDefault();
    this.props.logoClick();
  }

  render() {
    const {
      classes,
      title,
      drawerMap,
      customerName,
      logoutAction,
      reference,
      customerFirstName,
      gaEvent,
      bannerMessage,
      bannerOnYes,
      bannerOnNo,
      bannerOnRemindLater,
      showBanner,
    } = this.props;
    const { drawerOpen } = this.state;

    const homeItem = drawerMap[0];

    return (
      <div className="PortalAppBar">
        <Typography>
          <a href="#main" className={classes.skip} onClick={this.skip}>
            Skip to main content
          </a>
        </Typography>
        <Hidden mdUp>
          <GlobalDrawer
            open={drawerOpen}
            toggleDrawer={this.toggleDrawer}
            list={<GlobalDrawerList items={drawerMap} />}
            handleLogoClick={this.handleLogoClick}
            logoutAction={logoutAction}
          />
        </Hidden>
        <div className={`${classes.root} mui-fixed`} id="PortalAppBar">
          <AppBar position="static" className={classes.appbar}>
            {showBanner && (
              <PortalBanner
                message={bannerMessage}
                onYes={bannerOnYes}
                onNo={bannerOnNo}
                onRemindLater={bannerOnRemindLater}
              />
            )}
            <div className={classes.toolbarWrapper}>
              <Toolbar className={classes.toolbar}>
                <IconButton
                  className={classes.menuButton}
                  aria-label="Menu"
                  onClick={this.toggleDrawer}
                >
                  <MenuIcon />
                </IconButton>
                <a
                  href="#/"
                  onClick={this.handleLogoClick}
                  className={classes.logoContainer}
                >
                  <img
                    src={logo}
                    alt={'MyKāingaOra logo'}
                    className={classes.logo}
                  />
                </a>
                <div className={classes.titleBar}>
                  <div className={classes.appbarTitle}>
                    <Typography
                      component="p"
                      variant="h1"
                      className={classes.greeting}
                    >
                      {getString(stringsComponent, 'GREETING')}{' '}
                      {customerFirstName}
                    </Typography>
                  </div>
                  <div className={classes.appBarRight}>
                    <div>
                      <LocaleSelector
                        customerReference={reference}
                        gaEvent={gaEvent}
                      />
                    </div>
                    <div>
                      <Button
                        className={classes.logoutButton}
                        onClick={logoutAction}
                        variant="outlined"
                        color="primary"
                      >
                        {getString(stringsComponent, 'LOGOUT_LABEL')}
                      </Button>
                    </div>
                  </div>
                </div>
              </Toolbar>
            </div>
            <div className={classes.underbar}>
              <div className={classes.breadcrumbs}>
                <Typography
                  component="div"
                  variant="h4"
                  className={classes.breadcrumbsContainer}
                >
                  <Breadcrumbs homeClickHandler={homeItem.clickHandler} />
                </Typography>
              </div>
            </div>
          </AppBar>
        </div>
      </div>
    );
  }
}

PortalAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  customerName: PropTypes.string,
  logoClick: PropTypes.func.isRequired,
  gaEvent: PropTypes.func.isRequired,
};

PortalAppBar.defaultProps = {
  title: '',
  customerName: '',
};

export default withStyles(styles, { withTheme: true })(PortalAppBar);
